import type { HttpMock } from '#e2e-utils/mockScenarios';
import { ControllerStatus } from '#models/ControllerStatus.enum';
import type { ControllerDetails } from '#services/cve/ControllerDetails';

export const gerlCommentMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/Gerl$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'Gerl',
        statusCode: ControllerStatus.ACKNOWLEDGED_WITH_CHECK_SUCCESS,
        check: {
          requestDateTime: '2024-05-18T13:29:56.409Z',
          responseDateTime: '2024-05-18T13:29:56.409Z',
          requestorId: 'CVE',
          expirationDateTime: '2999-09-26T00:00:00.000Z',
          controlData: {
            companyId: '113',
            comment: `Date of the last update of the GERL: 12/09/2024
Is the company GERL compliant?: Yes
Is the company the Ultimate Parent?: Yes
Is the Ultimate Parent company GERL compliant?: Yes
Is there related entities in the GERL?: No `,
          },
        },
        validation: {
          requestorId: 'CVE',
          validationDateTime: '2024-05-19T13:29:56.409Z',
        },
      } satisfies ControllerDetails,
    },
  },
];
